/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Pinleft2Inputs */

const en_datagrid_pinleft2 = /** @type {(inputs: Datagrid_Pinleft2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin to left`)
};

/**
* | output |
* | --- |
* | "Pin to left" |
*
* @param {Datagrid_Pinleft2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_pinleft2 = /** @type {((inputs?: Datagrid_Pinleft2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Pinleft2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_pinleft2(inputs)
});
export { datagrid_pinleft2 as "dataGrid_pinLeft" }